import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

const MEDIA_SELECTOR = '[data-cars-media-swiper]'
const THUMBS_SELECTOR = '[data-cars-thumbs-swiper]'

const initGallery = (mediaContainer) => {
    if (mediaContainer.dataset.carsSwiperReady === 'true') {
        return
    }

    const gallery =
        mediaContainer.closest('[data-cars-gallery]') ??
        mediaContainer.parentElement
    const thumbsContainer = gallery?.querySelector(THUMBS_SELECTOR)
    const prevEl = mediaContainer.querySelector('.swiper-prev-cars')
    const nextEl = mediaContainer.querySelector('.swiper-next-cars')

    if (!gallery || !thumbsContainer) {
        return
    }

    const thumbsSwiper = new Swiper(thumbsContainer, {
        slidesPerView: 3,
        spaceBetween: 12,
        watchOverflow: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
            576: {
                slidesPerView: 4
            },
            1024: {
                slidesPerView: 6
            }
        }
    })

    new Swiper(mediaContainer, {
        modules: [Navigation, Thumbs],
        slidesPerView: 1,
        spaceBetween: 12,
        preventInteractionOnTransition: true,
        navigation:
            prevEl && nextEl
                ? {
                      prevEl,
                      nextEl
                  }
                : undefined,
        thumbs: {
            swiper: thumbsSwiper
        }
    })

    mediaContainer.dataset.carsSwiperReady = 'true'
    thumbsContainer.dataset.carsSwiperReady = 'true'
}

const init = async () => {
    return new Promise((resolve) => {
        const carsMediaSwiper = document.querySelectorAll(MEDIA_SELECTOR)

        if (carsMediaSwiper.length === 0) {
            return resolve('Cars swiper skipped')
        }

        carsMediaSwiper.forEach((mediaContainer) => {
            initGallery(mediaContainer)
        })

        return resolve('Cars swiper loaded')
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        init()
    })
} else {
    init()
}

export { init }
